import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { slideUp, slideUpMenu } from 'src/app/animations';
import { DataService } from 'src/app/_services/data.service';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';
// import "@lottiefiles/lottie-player";

// @NgModule.CUSTOM_ELEMENTS_SCHEMA({
//   schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
//   })

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.scss'],
  host: { '[class.active]': 'showMenu' },
  animations: [
    slideUp, slideUpMenu
  ]
})
export class RightMenuComponent implements OnInit {

  // @Input() proj: any;
  proj: any;
  modulesArray: any[] = [];
  showBuildingSubMenu: boolean = false;
  showFloorsViewSubMenu: boolean = false;
  showSubGallery: boolean = false;
  showMapViewSubMenu: boolean = false;
  compositeDesign: boolean = false;
  unika: boolean = false;
  showMenu: boolean = true;
  desktopResolution: boolean = true;
  routeParams: {};
  projId: string;
  projUid: string;
  galleryIdInput: any;
  params: any;
  projectlist: boolean = true;
  removeListOfProjects: boolean;
  removeAllMenu: boolean = false;
  iframeElement;
  @HostBinding('class.hide-menu') hideMenu: boolean = false;
  urlSwitcher: string = '';
  seheluser: string = '';
  sehelProjId: string = '';
  subRightmenuShow: boolean = false;
  showAboutProject: boolean = false;
  hideAboutMenu: boolean = false;
  hideMapSubMenu: boolean = false;
  hoisUrl: string;
  currentLanguage: string = 'he';
  allowMapViewSubMenu: boolean = false;
  enableCustomMarkers: boolean = false;
  additionalCategories: any[] = [];

  constructor(private route: ActivatedRoute, private router: Router, public dataService: DataService) { }

  ngOnInit(): void {
    this.sehelProjId = this.route.firstChild.snapshot.params.sehelProjId;
    this.seheluser = this.route.firstChild.snapshot.params.seheluser;
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    this.hoisUrl = this.dataService.hoisUrl();
    if (this.route.snapshot.queryParams.lang) {
      this.currentLanguage = this.route.snapshot.queryParams.lang;
    }
    if (window.innerWidth < 1200) {
      this.desktopResolution = false;
    }


      if (this.route.firstChild) {
        this.projUid = this.route.firstChild.snapshot.params.idp
        if (!this.projUid) {
          this.hideMenu = true;
        }
        this.routeParams = this.route.firstChild.snapshot.params;
        this.routeParams = this.route.firstChild.snapshot.params;
        this.dataService.getSpecProject(this.projUid).subscribe(proj => {
          this.proj = proj;
          this.projId = this.proj[0].id;
          this.modulesArray = this.proj[0].modules;
          this.hideAboutMenu = this.proj[0].hideAboutProjectShow;
          this.hideMapSubMenu = this.proj[0].hideMapSubMenu;
          this.enableCustomMarkers = this.proj[0].enableCustomMarkers;
          
          this.additionalCategories = this.proj[0].customCategories;

          
          this.switchModules(this.proj[0]);
        })
      } else {
        this.projUid = this.route.snapshot.params.idp;
        if (!this.projUid) {
          this.hideMenu = true;
        }
        this.routeParams = this.route.snapshot.params;
        this.projId = this.proj.id;
        this.modulesArray = this.proj.modules;
        this.switchModules(this.proj);
        this.routeParams = this.route.snapshot.params;
      }
    


    this.route.url.subscribe(segment => {
      segment.values;
      if (segment.length > 3) {
        for (let i = 0; segment.length > i; i++) {
          if (segment[i].path === 'n') {
            this.compositeDesign = true;
          } else if (segment[i].path === 'u') {
            this.compositeDesign = true;
            this.unika = true;
          }
        }
      }
    })
    if (this.route.snapshot.params.galleryId) {
      this.galleryIdInput = this.route.snapshot.params.galleryId;
    }
    this.route.queryParamMap.subscribe(params => {
      this.params = params;
      if (this.params.params.m !== undefined) {
        this.removeListOfProjects = true;
        if (this.params.params.m === 'all') {
          // this.projPassToParentShowMenu.emit('true');
          this.removeAllMenu = true;
          this.hideMenu = true;
          this.showMenu = false;
          this.removeListOfProjects = true;
          localStorage.setItem('removeAllMenu', JSON.stringify(true));
        } else {
          localStorage.setItem('removeAllMenu', JSON.stringify(false));
        }
      } else {
        localStorage.setItem('removeAllMenu', JSON.stringify(false));
      }
    });

  }

  currentModulesOnStart() {
    if (this.modulesArray[0]) {
      if (this.params.params.m.length > 0) {
        let array = this.params.params.m.split(',');
        for (let i = 0; array.length > i; i++) {
          switch (array[i]) {
            case 'currentsituation':
              this.modulesArray[0]['currentSituationTitle'] = false;
              break;
            case 'video':
              this.modulesArray[0]['videoTitle'] = false;
              break;
            case 'pdf':
              this.modulesArray[0]['pdfTitle'] = false;
              break;
            case 'area':
              this.modulesArray[0]['areaTitle'] = false;
              break;
            case 'floors':
              this.modulesArray[0]['floorsTitle'] = false;
              break;
            case 'simulators':
              this.modulesArray[0]['simulatorsTitle'] = false;
              break;
            case 'buildings':
              this.modulesArray[0]['buildingsTitle'] = false;
              break;
            case 'constructionpoint':
              this.modulesArray[0]['constructionPointTitle'] = false;
              break;
            case 'linkToSite':
              this.modulesArray[0]['linkToSiteTitle'] = false;
              break;
            case 'simple':
              this.modulesArray[0]['simpleTitle'] = false;
              break;
            case 'simple1':
              this.modulesArray[0]['simple1Title'] = false;
              break;
            case 'simple2':
              this.modulesArray[0]['simple2Title'] = false;
              break;
            case 'simple3':
              this.modulesArray[0]['simple3Title'] = false;
              break;
            // case 'allgalleries':
            //   this.allgalleries = false;
            //   break;
            case 'projectlist':
              this.projectlist = false;
              break;
          }
        }
      }
    }
  }
  goToProject() {
    if (this.route.firstChild) {
      if (this.seheluser) {
        this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/' + 'seheluser/' + this.seheluser]);
      } else {
        this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid],{
          queryParams: { lang: this.currentLanguage },
          queryParamsHandling: 'merge' // Merges with any existing query params in the URL
        });
      }
    }
    this.goToHomePano();
    this.ifShowMenu();
  }
  aboutProject(){
    this.showFloorsViewSubMenu = false;
    this.showSubGallery = false;
    this.showBuildingSubMenu = false;
    this.showMapViewSubMenu = false;
    this.subRightmenuShow = false;
    if (this.route.firstChild) {
      if (this.seheluser) {
        // this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/' + 'seheluser/' + this.seheluser + '/about']);
      } else {
        this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/about'], {
          queryParams: { lang: this.currentLanguage },
          queryParamsHandling: 'merge' // Merges with any existing query params in the URL
        });
      }
    }
  }
  goToHomePano() {
    // this.closeViewFloors();
    this.showBuildingSubMenu = false;
    this.showFloorsViewSubMenu = false;
    this.showSubGallery = false;
    this.subRightmenuShow = false;
    this.showMapViewSubMenu = false;
    const data = {
      scene: this.proj.panoramaView, // pano ID
      autorotate: false,
    };
    // Set url to be sure that the message will be sent to only this url
    // Full url to iframe

    postMessageToIframe(data);

    // const url = 'https://topeye.club/';
    // //  Access iframe by name
    // // const win = window.frames.tourIframe;
    // const test = document.getElementsByClassName("da-iframe");
    // let test1: HTMLIFrameElement;
    // if (test.length > 0) {
    //   const test1 = test[0].getElementsByTagName('iframe')[0];
    // }
    // const win = test1;

    // if (win) {
    //   this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
    //   this.iframeElement.postMessage(JSON.stringify(data), url);
    // }
  }

  switchModules(items) {
    if (items.modules) {
      for (let i = 0; items.modules.length > i; i++) {
        const moduleNameTrigger = items.modules[i];
        // this.modulesArray[0][moduleNameTrigger.moduleName] = true;
        if (this.modulesArray[0]) {
          switch (moduleNameTrigger.moduleName) {
            case 'currentSituation':
              this.modulesArray[0]['currentSituationTitle'] = moduleNameTrigger.currentSituationTitle;
              break;
            case 'video':
              this.modulesArray[0]['videoTitle'] = moduleNameTrigger.videoTitle;
              break;
            case 'pdf':
              this.modulesArray[0]['pdfTitle'] = moduleNameTrigger.pdfTitle;
              break;
            case 'area':
              this.modulesArray[0]['areaTitle'] = moduleNameTrigger.areaTitle;
              break;
            case 'floors':
              this.modulesArray[0]['floorsTitle'] = moduleNameTrigger.floorsTitle;
              break;
            case 'simulators':
              this.modulesArray[0]['simulatorsTitle'] = moduleNameTrigger.simulatorsTitle;
              break;
            case 'buildings':
              this.modulesArray[0]['buildingsTitle'] = moduleNameTrigger.buildingsTitle;
              break;
            case 'constructionPoint':
              this.modulesArray[0]['constructionPointTitle'] = moduleNameTrigger.constructionPointTitle;
              break;
            case 'linkToSite':
              this.modulesArray[0]['linkToSiteTitle'] = moduleNameTrigger.linkToSiteTitle;
              break;
            case 'simple':
              this.modulesArray[0]['simpleTitle'] = moduleNameTrigger.simpleTitle;
              break;
            case 'simple1':
              this.modulesArray[0]['simple1Title'] = moduleNameTrigger.simple1Title;
              break;
            case 'simple2':
              this.modulesArray[0]['simple2Title'] = moduleNameTrigger.simple2Title;
              break;
            case 'simple3':
              this.modulesArray[0]['simple3Title'] = moduleNameTrigger.simple3Title;
              break;
            default:
          }
        }
        if (this.params.params.m) {
          this.currentModulesOnStart();
        }
      }
    }
  };

  screenResolutionDetecting() {
    return window.innerWidth;
  }

  ifShowMenu() {
    if (this.screenResolutionDetecting() < 1200) {
      this.showMenu = !this.showMenu;
      if (!this.showMenu) {
        document.getElementsByClassName("menu")[0].classList.remove('active');
        document.getElementsByClassName("menu")[0].parentElement.classList.remove('active');
      }
    }
  }
  openBuildingsFocus(whichMenu){
    if(window.innerWidth > 20200) {
      this.openBuildings(whichMenu, 'focus');
    }
  }
  showSubGalleryFocus(event){
    if(window.innerWidth > 20200) {
      this.showSubGalleryF(event);
    }
  }
  openBuildings(whichMenu, ifFocus?) {
    // this.ifClick = 
    if (whichMenu === 'buildMenu') {
      this.dataService.getItemsByProjId(this.projId).subscribe(buildList => {
        if(buildList.length === 1){
          this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/building/' + buildList[0].uid], {
            queryParams: { lang: this.currentLanguage },
            queryParamsHandling: 'merge' // Merges with any existing query params in the URL
          });
        } else {
          this.showBuildingSubMenu = !this.showBuildingSubMenu;
          this.showFloorsViewSubMenu = false;
          this.showSubGallery = false;
          this.subRightmenuShow = false;
          this.showMapViewSubMenu = false;
        }
      })


    } else if (whichMenu === 'floorMenu') {
      this.showBuildingSubMenu = false;
      this.showFloorsViewSubMenu = !this.showFloorsViewSubMenu;
      this.showSubGallery = false;
      this.subRightmenuShow = false;
      this.showMapViewSubMenu = false;
    } else if (whichMenu === 'buildMenuSub' || whichMenu === 'floorMenuSub') {
      this.showFloorsViewSubMenu = false;
      this.showSubGallery = false;
      this.showBuildingSubMenu = false;
      this.subRightmenuShow = false;
      this.showMapViewSubMenu = false;
      if (this.screenResolutionDetecting() < 1200) {
        // this.showMenuF()
        this.ifShowMenu();
        // this.showMenu = false;
      }
    } else if (whichMenu === 'sub'){
      this.showFloorsViewSubMenu = false;
      this.showSubGallery = false;
      this.showBuildingSubMenu = false;
      this.subRightmenuShow = !this.subRightmenuShow;
      this.showMapViewSubMenu = false;
    } else if(whichMenu === 'showMapViewSubMenu'){
      this.showFloorsViewSubMenu = false;
      this.showSubGallery = false;
      this.showBuildingSubMenu = false;
      this.showMapViewSubMenu = !this.showMapViewSubMenu;
      this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.projUid + '/nearbyProject'], {
        queryParams: { lang: this.currentLanguage },
        queryParamsHandling: 'merge' // Merges with any existing query params in the URL
      });
    } else if(whichMenu === 'showAboutProject'){
      this.showFloorsViewSubMenu = false;
      this.showSubGallery = false;
      this.showBuildingSubMenu = false;
      this.showMapViewSubMenu = false;
      this.showAboutProject = !this.showAboutProject;
      this.aboutProject();
      this.subRightmenuShow = false;
    } 
    
  }

  showMapViewSubMenuF(showMapViewSubMenu){
    this.showMapViewSubMenu = false;
    this.subRightmenuShow = false;
  }

  showSubGalleryF($event) {
    this.showSubGallery = !this.showSubGallery;
    this.showBuildingSubMenu = false;
    this.showFloorsViewSubMenu = false;
    this.subRightmenuShow = false;
    this.showMapViewSubMenu = false;
  }

  closeSubMenu(event) {
    // this.galleryType = "";
    this.showSubGallery = event;
    if (!this.desktopResolution) {
      this.showMenu = event;
    }
  }

}
